import $ from 'jquery'
import { Modal } from 'bootstrap'
import slugify from 'slugify'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { Alert } from './functions'
import IMask from 'imask'

const object = vnObject

/*const masks = document.querySelectorAll('.vn-phone-mask')
if (masks) {
  ;[...masks].map((mask) => {
    IMask(mask, {
      mask: '+33 \\00 00 00 00 00',
      lazy: false,
      placeholderChar: 'x',
    })
  })
}*/

$('.vn-phone-mask').blur(function() {
  var phone = $(this).val().trim()
  if (!phone.startsWith('+')) {
    Alert('warning', object.wrongPhone, false)
    $(this).val('')
  }
});

window.Parsley.addValidator('frNumber', {
  requirementType: 'string',
  validateString: function (value) {
    return isValidPhoneNumber(value, 'FR')
  },
})

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('data-url')
})

$('.open-in-new-tab').on('click', function (e) {
  e.preventDefault()
  window.open($(this).attr('data-url'), '_blank').focus()
})

const scrolls = document.querySelectorAll('[data-scroll-to]')
if (scrolls.length) {
  ;[...scrolls].map((scroll) => {
    scroll.addEventListener('click', () => {
      const scrollEl = document.querySelector(
        scroll.getAttribute('data-scroll-to')
      )
      if ($(window).width() < 992) {
        var topOfElement = scrollEl.offsetTop - 70;
        window.scroll({ top: topOfElement, behavior: 'smooth' });
      }
      else {
        scrollEl.scrollIntoView({ behavior: 'smooth' })
      }
      document.body.classList.remove('training-filter-active')
    })
  })
}

const appendToSummary = (item, index) => {
  const text = item.text().replace(':', '')
  const slug =
    slugify(item.text(), {
      replacement: '_',
      lower: true,
      strict: true,
      remove: /[*+~.()'"!:@]/g,
    }) + `_${index}`

  item.attr('id', slug)

  const url = $(`<li><a href="#${slug}">${text}</a></li>`)
  url.appendTo('.training-summary > ul')
}

$('.entry-content--training')
  .find('.summary-title')
  .each(function (i) {
    appendToSummary($(this), i)
  })

$('.summarize-content')
  .find('h2,h3,h4,h5,h6,.summary-title')
  .each(function (i) {
    appendToSummary($(this), i)
  })

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})

$('.vn-excerpt__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.vn-excerpt')

  if (button_parent.hasClass('vn-excerpt--active')) {
    button.find('.vn-a-content').html(object.readMore)
  } else {
    button.find('.vn-a-content').html(object.readLess)
  }

  button_parent.toggleClass('vn-excerpt--active')
})
